import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter as Router} from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import { createStore, applyMiddleware } from "redux";
import rootReducer from "./Firebase/reducers/rootReducer";
import 'firebase/auth'
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { getFirebase, ReactReduxFirebaseProvider } from "react-redux-firebase";
import firebase from "./Firebase/config/FirebaseConfig";
import { createFirestoreInstance } from "redux-firestore";
import { useSelector } from "react-redux";
import { isLoaded } from "react-redux-firebase";
import MainLoading from './components/Loading/MainLoading';


const store = createStore(
  rootReducer,
  applyMiddleware(thunk.withExtraArgument({ getFirebase }))
);

const rrfProps = {
  firebase,
  config: {
    userProfile: 'students', // where profiles are stored in database
    useFirestoreForProfile: true // use Firestore for profile instead of RTDB
  },
  dispatch: store.dispatch,
  createFirestoreInstance,
};

function AuthIsLoaded({children}) {
  const auth = useSelector(state => state.firebase.auth)
  if(!isLoaded(auth)) return <MainLoading />;
  return children
}

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <AuthIsLoaded>
      <Router>
        <ScrollToTop />
        <App />
      </Router>
      </AuthIsLoaded>
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById("root")
);